import React, { PureComponent } from "react";
import ArrowIcon from '../../containers/assets/dropdown-arrow.svg';
import isArray from "lodash/isArray";
import {
  DropDownHeader,
  DropDownListContainer,
  DropDownList,
  DropDownContainer,
  DropDownHeaderArrow,
  DropDownListItem,
} from '../styles/dashboard';

class DashboardSelect extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      selectedOption: null
    };

    this.wrapperRef = null;
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);

    if (this.props.setValueCallback) {
      const dummyCallback = () => {};
      const onChange = this.props.onChange || dummyCallback;

      this.props.setValueCallback(value => {
        this.onOptionClicked(value, onChange)();
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  toggling = () => {
    const { isOpen } = this.state;

    this.setState({
      isOpen: !isOpen
    });
  };

  onOptionClicked = (value, callback) => () => {
    this.setState(
      {
        selectedOption: value,
        isOpen: false
      },
      () => {
        if (callback) {
          callback(value);
        }
      }
    );
  };

  handleClickOutside = e => {
    const { isOpen } = this.state;

    if (isOpen && this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({
        isOpen: false
      });
    }
  };

  get title() {
    const { selectedOption } = this.state;
    const { placeholder, options, customId, customName } = this.props;

    if (selectedOption) {
      if (customId && customName) {
        const selected = options.find(i => i[customId] === selectedOption);

        return selected ? selected[customName] : placeholder;
      }

      return isArray(options) ? selectedOption : options[selectedOption];
    }

    return placeholder;
  }

  render() {
    const { isOpen, selectedOption } = this.state;
    const { options, placeholder, customId, customName } = this.props;
    const DropDownContainerComponent = this.props.DropDownContainer || DropDownContainer;
    const DropDownHeaderComponent = this.props.DropDownHeader || DropDownHeader;
    const DropDownListContainerComponent =
      this.props.DropDownListContainer || DropDownListContainer;
    const DropDownListComponent = this.props.DropDownList || DropDownList;
    const DropDownHeaderArrowComponent = this.props.DropDownHeaderArrow || DropDownHeaderArrow;
    const ArrowIconComponent = this.props.ArrowIcon || ArrowIcon;
    const dummyCallback = () => {};
    const onChange = this.props.onChange || dummyCallback;
    const customRender = customId && customName ? true : false;

    return (
      <DropDownContainerComponent
        innerRef={wrapperRef => {
          this.wrapperRef = wrapperRef;
        }}
      >
        <DropDownHeaderComponent
          onClick={this.toggling}
          title={selectedOption || placeholder}
        >
          {this.title}
          <DropDownHeaderArrowComponent>
            <img src={ArrowIconComponent} alt="" />
          </DropDownHeaderArrowComponent>
        </DropDownHeaderComponent>
        {isOpen && (
          <DropDownListContainerComponent>
            <DropDownListComponent>
              {isArray(options) &&
                !customRender &&
                options.map((option, i) => (
                  <DropDownListItem
                    key={i}
                    onClick={this.onOptionClicked(option, onChange)}
                    isSelected={selectedOption === option ? true : false}
                  >
                    {option}
                  </DropDownListItem>
                ))}
              {isArray(options) &&
                customRender &&
                options.map((option, i) => (
                  <DropDownListItem
                    key={i}
                    onClick={this.onOptionClicked(option[customId], onChange)}
                    isSelected={
                      selectedOption === option[customId] ? true : false
                    }
                  >
                    {option[customName]}
                  </DropDownListItem>
                ))}
              {!isArray(options) &&
                Object.keys(options).map(id => (
                  <DropDownListItem
                    key={id}
                    onClick={this.onOptionClicked(id, onChange)}
                    isSelected={selectedOption === id ? true : false}
                  >
                    {options[id]}
                  </DropDownListItem>
                ))}
            </DropDownListComponent>
          </DropDownListContainerComponent>
        )}
      </DropDownContainerComponent>
    );
  }
}

export default DashboardSelect;



// WEBPACK FOOTER //
// ./src/instructor/components/dashboard-select.js